import styled from "styled-components";
import { styled as muiStyled } from '@mui/material/styles';
import { dark, thirdly } from "styles/theme";
import { Boy } from '@mui/icons-material';
import { Center, CenterStyle, Scroll } from "styles/GlobalCss";
import { white } from "styles/theme";
import { Accordion, Box, Button, SvgIcon, Tabs } from "@mui/material";
import { thirdly2 } from "styles/theme";
import { thirdly4 } from "styles/theme";

const graphH = '33px'

const RateAndAccuracyDescription = styled.div`
`

const WrapGraphTexts = styled.div`
display:flex;
flex-direction: column;
width: 70px;
font-size:15px;
row-gap:10px;

.wrap-graph-text{
display: flex;
height:40px;
column-gap:5px;
align-items: end;
}

.graph-text{
}

.graph-icon{
transform:rotate(180deg);
}
`

const ChildrenGraphStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    columnGap: 15,
    '.children-count': {
        display: "flex",
        columnGap: 3
    }
}))

const AssessmentDistributionStyles = muiStyled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '.distribution-content': {
        backgroundColor: "white",
        height: 444,
        width: 888,
        ...CenterStyle
    }
}))


const WrapAccordion = muiStyled(Accordion)(({ theme }) => (
    {
        '&.MuiAccordion-root': {
            boxShadow: "none",
            borderBottom: `1px solid ${thirdly2}`,
            position: "unset",
        },
        '&.MuiAccordionSummary-root': {
            height: "100px !important",
        },
        fontSize: '16px',
        '.tab-title': {
            display: "flex",
            alignItems: "center",
            columnGap: "10px"
        }
    }))

const WrapTabs = muiStyled(Tabs)(({ theme }) => (
    {
        '& .Mui-selected': {
            color: `${dark} !important`,
            fontWeight: "bold"
        }
    }))

const RateAndAccuracyLabel = styled.div`
background-color:${white};
border-radius:7px;
padding:5px;
`

const WrapReports = styled.div`
display: flex;
row-gap: 10px;
flex-direction: column;
height:100%;
flex-grow: 1;
overflow: auto;
font-size:16px;
`

const WrapTitle = styled.div`
font-size:18px;
`

const WrapNumChild = styled.div`
font-size:11px;
text-align: center;
height:18px;
color:${props => props.theme.color};
// text-shadow: ${props => `0.5px 0.5px 0.5px ${props.theme.color}`};
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
direction: rtl;
padding: 4px 2px;
box-sizing: border-box;
`

const WrapIcon = styled(SvgIcon)`
width:20px !important;
height:20px !important;
path{
fill:${props => props.theme.color} !important;
}
`

const WrapGraphItem = styled.div`
flex-grow: 1;
display: flex;
flex-direction: column;
align-items: center;
${props => props.current_test_taker && `
border-radius:8px;
border:1px solid ${thirdly};
border-bottom-left-radius: 0px;
border-bottom-right-radius: 0px;
`} 
`

const WrapChild = styled.div`
height:37px;
${Center};

`

const Number = styled.div`

`


const BoldSummary = styled.span`
color:${props => props.color};
`

const Rate = styled.div`
width:100%;
box-sizing:border-box;
background:${props => props.color};
border-radius: 2px;
padding:5px;
font-weight:400;
font-size:15px;
`

const GraphNumber = styled.span`
height: 35px;
color:${props => props.theme.color};
width: 100%;
background:${props => props.isDrag ? thirdly4 : white};
display: flex;
justify-content: center;
align-items:center;
font-size:12px;

`


const WrapGraph = styled.span`
opacity:${props => props.disabled && "0.5"};
overflow-x:auto;
flex-grow:1;
overflow-y:hidden;
display:flex;
direction: ltr;
height:${props => props.showFooter ? 155 : 100}px;
align-items: center;
width:100%;
${Scroll};
`



export { RateAndAccuracyLabel, AssessmentDistributionStyles, WrapGraphTexts, ChildrenGraphStyles, WrapTitle, WrapTabs, RateAndAccuracyDescription, WrapAccordion, WrapNumChild, WrapIcon, WrapChild, WrapGraphItem, WrapGraph, GraphNumber, BoldSummary, Rate, Number, WrapReports }